import React, { createContext, useContext, useEffect, useState } from "react";
import { PRICE } from "@/lib/catalog";

const CartContext = createContext(null);
const KEY = "tony_rays_cart";

export const CartProvider = ({ children }) => {
    const [items, setItems] = useState(() => {
        try {
            return JSON.parse(localStorage.getItem(KEY)) || [];
        } catch {
            return [];
        }
    });

    useEffect(() => {
        localStorage.setItem(KEY, JSON.stringify(items));
    }, [items]);

    const addItem = (config) => {
        setItems((prev) => {
            const idx = prev.findIndex(
                (i) =>
                    i.category === config.category &&
                    i.gender === config.gender &&
                    i.style === config.style &&
                    i.color === config.color &&
                    i.size === config.size &&
                    i.boxType === config.boxType,
            );
            if (idx >= 0) {
                const copy = [...prev];
                copy[idx] = {
                    ...copy[idx],
                    quantity: copy[idx].quantity + (config.quantity || 1),
                };
                return copy;
            }
            return [
                ...prev,
                {
                    id: `${Date.now()}-${Math.random().toString(36).slice(2, 7)}`,
                    quantity: config.quantity || 1,
                    ...config,
                },
            ];
        });
    };

    const updateQty = (id, quantity) => {
        if (quantity < 1) return;
        setItems((prev) =>
            prev.map((i) => (i.id === id ? { ...i, quantity } : i)),
        );
    };

    const removeItem = (id) =>
        setItems((prev) => prev.filter((i) => i.id !== id));

    const clear = () => setItems([]);

    const count = items.reduce((n, i) => n + i.quantity, 0);
    const total = count * PRICE;

    return (
        <CartContext.Provider
            value={{ items, addItem, updateQty, removeItem, clear, count, total }}
        >
            {children}
        </CartContext.Provider>
    );
};

export const useCart = () => useContext(CartContext);
